module.exports = __webpack_public_path__ + "static/media/tentWhite.f81ad872.svg";